import { Button, Input, Space } from "antd";
import { useEffect, useState } from "react";

export interface UserLabelProps {
    info?: string[];
    onChange?: (value: string[]) => void;
}

// 缺省标签数组保持稳定引用，避免编辑表单中的 effect 因默认参数反复触发状态更新。
const EMPTY_USER_LABELS: string[] = [];

/** 用户标签编辑器，最多保留五个标签并同步受控值。 */
export default function UserLabel({ info = EMPTY_USER_LABELS, onChange }: UserLabelProps) {
    const [labels, setLabels] = useState<string[]>(info.length ? info : [""]);
    useEffect(() => {
        setLabels(info.length ? info : [""]);
    }, [info]);
    const update = (next: string[]) => {
        setLabels(next);
        onChange?.(next);
    };
    return (
        <Space wrap>
            {labels.map((label, index) => (
                <Space.Compact key={index}>
                    <Input
                        maxLength={6}
                        placeholder="请输入用户标签"
                        value={label}
                        onChange={event => update(labels.map((item, i) => (i === index ? event.target.value : item)))}
                    />
                    <Button onClick={() => update(labels.filter((_, i) => i !== index))}>删除</Button>
                </Space.Compact>
            ))}
            <Button disabled={labels.length >= 5} onClick={() => update([...labels, ""])}>
                新增用户标签
            </Button>
        </Space>
    );
}
